<!-- The pin is a button of its own, so it cannot live inside the card's link:
	nesting one interactive element in another is invalid and leaves the pin
	unreachable by keyboard. Instead the link stretches over the card through its
	`after` pseudo-element, and the pin — positioned, and later in the DOM — sits
	above it. Tapping the pin therefore never opens the symbol board. -->
<div class="relative rounded-2xl bg-gray-000 p-3">
	<div class="flex flex-col">
		<div class="flex items-start justify-between gap-2">
			<div class="flex min-w-0 flex-1 items-start gap-1.5">
				<a
					class="block min-w-0 cursor-pointer after:absolute after:inset-0 after:rounded-2xl"
					data-cy="symbol-card"
					[attr.aria-label]="'نمایش جزئیات ' + item().title"
					[routerLink]="['/symbol-details', item().id]">
					<div class="flex items-center gap-1.5">
						<ui-icon width="24" height="24" class="shrink-0 text-gray-900" [iconName]="item().icon" />
						<h2 class="truncate text-3.25 font-bold text-gray-900">{{ item().title }}</h2>
					</div>
					<p class="truncate text-2.75 pt-0.5 text-gray-500">{{ item().subtitle }}</p>
				</a>
			</div>

			<ui-icon
				class="relative cursor-pointer text-gray-700"
				width="20"
				height="20"
				role="button"
				tabindex="0"
				data-cy="symbol-card-pin"
				[attr.aria-label]="item().pinned ? 'حذف پین ' + item().title : 'پین کردن ' + item().title"
				[attr.aria-pressed]="item().pinned"
				[iconName]="pinIcon()"
				(click)="onPinClick()"
				(keydown.enter)="onPinClick()"
				(keydown.space)="onPinClick()" />
		</div>

		<div class="flex items-end justify-between gap-3">
			<div class="flex min-w-0 items-baseline gap-1 text-3.25">
				<span dir="ltr" [class]="changeClass()">{{ formattedChange() }}</span>
				<ui-number
					format="1.0-0"
					class="truncate font-bold tabular-nums text-gray-900"
					[value]="item().price" />
			</div>

			<app-symbol-sparkline [trades]="item().sparklineTrades" [baseline]="item().baseline" />
		</div>
	</div>
</div>
